import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/fontawesome-free-solid";
import { HeaderFilterButton } from "../../RemarkTemplate/Body";
import { withoutEmptyKeys } from "../../../util/object";
import AllTransactionsFilter from "../AllTransactions/components/AllTransactionsFilter";
import { operations } from "../../../util/operationsForFilters";
import { TemplateWrapped } from "../../Layout";
import useAllTransactionsTable from "../AllTransactions/components/useAllTransactionsTable";
import useColumnFlag from "../AllTransactions/components/ColumnGrid/ColumnFlag/hooks/useColumnFlag";
import TransactionTable from "../../TransactionTable";
import { transactionColorFlagColumn } from "../../../util/transactionColorFlagColumn";
import { transactionsColumnByModule } from "../../../util/transactionsColumnByModule";
import { transactionActionsColumnsByModule } from "../../../util/transactionActionsColumnsByModule";
import CustomModal from "../../CustomModal";
import FilesList from "../AllTransactions/components/FilesList";
import ConfirmExportExcel from "../AllTransactions/components/confirm-export-excel/ConfirmExportExcel";
import { useTransactionSegments } from "./hooks/useTransactionSegments";
import withSelectedPractices from "../../HOCS/withSelectedPractices/withSelectedPractices";
import { Navigate } from "react-router-dom";

const TransactionSegments = ({
  actions = {
    list_transaction_segments: true,
    audit_transaction: true,
    upload_elg: true,
    unaudit: false,
    updateElegibilityStatus: false,
  },
  permissions,
  ...props
}) => {
  const { selectedPractices } = props;
  const MODULE_KEY = "TS";

  const {
    _permissions,
    sortTransaction,
    filters,
    loaded,
    dateFilters,
    ref,
    setFilters,
    handleSetFilters,
    getData,
    refresh,
    key,
    userColumns,
    openModalVerification,
    showModalExport,
    setShowModalExport,
    downloadGridData,
    isDownloadingFile,
  } = useTransactionSegments(permissions, selectedPractices);

  const { handleIssueButtonClick } = useAllTransactionsTable(ref, "");

  const [filterOperation, setFilterOperation] = useState([]);
  const { flagColors, saveTransactionColor } = useColumnFlag(refresh);
  const { handleVerify, setFiles, setShowModal, files, showModal, history } =
    useAllTransactionsTable(ref, "practiceId");

  useEffect(() => {
    // TODO make API call
    setFilterOperation(operations);
  }, []);

  if (!actions.list_transaction_segments) return <Navigate to="/" />;

  const requiredColumn = "PatientId";

  const columnsWithPatientId = userColumns.includes(requiredColumn)
    ? userColumns
    : [...userColumns, requiredColumn];

  const showPatientIdColumn = Boolean(
    permissions?.transaction?.showPatientIdColumn,
  );

  return (
    <TemplateWrapped
      title="Transaction Segments"
      headerButtons={
        <React.Fragment>
          <div className="d-flex">
            {actions.export_data_transactions_segment && (
              <div
                className="d-flex align-items-center justify-content-center pointer"
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  background: "white",
                }}
                onClick={() => setShowModalExport(true)}
              >
                <FontAwesomeIcon icon={faArrowDown} />
              </div>
            )}
            {actions.filter_transactions_segment && (
              <HeaderFilterButton
                active={
                  filters && Object.keys(withoutEmptyKeys(filters)).length > 0
                }
                render={AllTransactionsFilter}
                componentProps={{
                  setFilters,
                  initialData: filters,
                  operations,
                  module_key: "TS",
                  showPatientIdColumn,
                }}
              />
            )}
          </div>
        </React.Fragment>
      }
    >
      <div className="panel">
        <div className="panel-body">
          <div className="row">
            <div className="col-md-12">
              {loaded && (
                <div className="all-transactions-table">
                  <TransactionTable
                    key={key} // Force a re-render to avoid material's table bug
                    colorFlagColumn={transactionColorFlagColumn(
                      flagColors,
                      saveTransactionColor,
                      _permissions,
                      MODULE_KEY,
                    )}
                    columns={transactionsColumnByModule(
                      MODULE_KEY,
                      Boolean(permissions.transaction?.showMissingColumn),
                    )}
                    actionsColumns={transactionActionsColumnsByModule(
                      history,
                      actions.unaudit,
                      handleVerify,
                      ref,
                      MODULE_KEY,
                      openModalVerification,
                      handleIssueButtonClick,
                      "practiceId",
                      false,
                      permissions,
                    )}
                    tableReference={ref}
                    asyncDataSource={getData}
                    filters={filters}
                    currentDate={dateFilters.currentDate}
                    sortTransaction={sortTransaction}
                    range={dateFilters.dateRange}
                    handleSetFilters={handleSetFilters}
                    filterOperation={filterOperation}
                    visibleColumns={columnsWithPatientId}
                    actions={actions}
                    module_key={MODULE_KEY}
                    permissions={{
                      ...permissions,
                      transaction: {
                        ...permissions.transaction,
                        showPatientIdColumn: true,
                      },
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <CustomModal
          size="xl"
          title="Files"
          onHide={() => {
            setShowModal(false);
            setFiles(null);
          }}
          show={showModal}
        >
          <FilesList
            id={files}
            practice={"practiceId"}
            canDownloadFiles={_permissions.files?.downloadFiles || false}
          />
        </CustomModal>
      )}

      <CustomModal
        show={showModalExport}
        onHide={() => setShowModalExport(false)}
        title="Confirmation"
        size="md"
        header={false}
      >
        <ConfirmExportExcel
          isDownloadingFile={isDownloadingFile}
          downloadGridData={downloadGridData}
          setShowModalExport={setShowModalExport}
        />
      </CustomModal>
    </TemplateWrapped>
  );
};

export default withSelectedPractices(TransactionSegments);
